import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, CircularProgress, Grid, Typography } from '@mui/material';

import { decrypt } from 'js/library/utils/helpers';
import { getUserInfoBasic_v1 } from 'js/library/utils/API/getUserInfo_v1';
import { loginUser } from 'js/library/services/AuthenticationManager';
import cfac22 from 'js/library/utils/cfac22';

export default function Entrance() {
  const { t } = useTranslation();
  const [destiny, setDestiny] = useState(null);
  const [success, setSuccess] = useState(null);

  try {
    //buscando variáveis da URL
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const userIdParams = urlParams.get('userId');
    const destinyParams = urlParams.get('destiny');

    //descriptografando valor
    const cellPhone = decrypt(userIdParams, cfac22('CRYPTO_KEY'));

    //obj de pesquisa
    const userInfo = {
      contactList: [
        {
          type: 'cellPhone',
          value: cellPhone,
        },
      ],
    };

    //buscando usuário
    getUserInfoBasic_v1(['getUserInfo'], userInfo).then(async (result) => {
      if (result !== null) {
        await loginUser(result.triiboId.replace(/[,]/gi, '.'), result.passPhrase);
        localStorage.setItem('userInfoAuxiliar', JSON.stringify(result));
        setDestiny(destinyParams);
        setSuccess(true);
      } else {
        setSuccess(false);
      }
    });
  } catch (error) {
    setSuccess(false);
  }

  if (success === true) {
    window.location = destiny;
  } else {
    return (
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        align="center"
        className="background-login"
      >
        <Grid size={{ md: 4, sm: 6, xs: 10 }}></Grid>

        <Grid size={{ md: 4, sm: 6, xs: 10 }}>
          {success === null ? (
            <>
              <CircularProgress />
              <Typography variant="h6">{t('general.wait_we_redirect_you')}</Typography>
            </>
          ) : (
            <>
              <Typography variant="h6">{t('errors.try_again')}</Typography>
              <a href={cfac22('homepage')} style={{ textDecoration: 'none' }}>
                <Button variant="contained" color="primary" style={{ textTransform: 'none' }}>
                  {t('general.go_back_triibo')}
                </Button>
              </a>
            </>
          )}
        </Grid>

        <Grid size={{ md: 4, sm: 6, xs: 10 }}></Grid>
      </Grid>
    );
  }
}
